'use client';

import { useTranslations } from 'next-intl';
import { CatButton } from 'components/blocks-components';
import { useBreakpoint } from 'components/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { NoActiveEquipmentMobileProps } from '../../../types';

export const SelectEquipmentButton = ({
  hasEquipments
}: Readonly<NoActiveEquipmentMobileProps>) => {
  const t = useTranslations();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const { addEquipmentDrawer, selectEquipmentDrawer } = useMyEquipmentDrawer();
  const handleDrawer = hasEquipments
    ? () => selectEquipmentDrawer.openDrawer()
    : () => addEquipmentDrawer.openDrawer();

  return (
    <CatButton
      variant="primary"
      fullWidth={!isMD}
      onClick={handleDrawer}
      data-track-event="e_primaryCTA"
      data-track-attr-nltext="Select Equipment"
      data-track-attr-context="Homepage Menu"
    >
      {t('SELECT_EQUIPMENT')}
    </CatButton>
  );
};
